import { useDarkTheme } from '@/contexts/DarkThemeContext'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import {
  antdTranslationResources,
  availableLanguages,
  type AvailableLanguageType,
  fallbackLng,
} from '@/locales/resources'
import { darkTheme } from '@/styles/theme/dark'
import { lightTheme } from '@/styles/theme/light'
import { darkTheme as newDarkTheme } from '@/styles/theme/new-theme/dark'
import { lightTheme as newLightTheme } from '@/styles/theme/new-theme/light'
import { ConfigProvider as AntdConfigProvider, type ThemeConfig } from 'antd'

const THEME_CONFIG_MAP: Record<string, { light: ThemeConfig; dark: ThemeConfig }> = {
  current: {
    light: lightTheme,
    dark: darkTheme,
  },
  new: {
    light: newLightTheme,
    dark: newDarkTheme,
  },
}

type ConfigProviderProps = React.PropsWithChildren & {
  language: string
}

export function ConfigProvider({ children, language }: ConfigProviderProps) {
  const { isDarkTheme } = useDarkTheme()

  const showNewDesignTokens = useFlag(DashboardExperiments.newDesignTokens)

  const themeName = showNewDesignTokens ? 'new' : 'current'
  const themeConfig = THEME_CONFIG_MAP[themeName]

  const localeKey = (
    availableLanguages.includes(language as AvailableLanguageType) ? language : fallbackLng
  ) as AvailableLanguageType

  const locale = antdTranslationResources[localeKey]

  return (
    <AntdConfigProvider theme={isDarkTheme ? themeConfig.dark : themeConfig.light} locale={locale}>
      {children}
    </AntdConfigProvider>
  )
}
